// extracted by mini-css-extract-plugin
export var columnList = "_dw-0";